import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=cfaf32a0&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=cfaf32a0&prod&scoped=true&lang=css"
import style1 from "./swiper.vue?vue&type=style&index=1&id=cfaf32a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf32a0",
  null
  
)

export default component.exports